import { HttpClient } from '@angular/common/http';
import { AfterContentInit, AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, DOCUMENT } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { DialogConfirmComponent } from 'src/app/dialog/dialog-confirm/dialog-confirm.component';
import { AppService, GRSSResponse } from 'src/app/_services/app.service';
import { DisplayDetailsComponent } from './display-details/display-details.component';
import { MarketContributeComponent } from './market-contribute/market-contribute.component';
import { Title } from '@angular/platform-browser';
import { formatNumber } from '@angular/common';
import moment from 'moment';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { PreviousContributionsComponent } from './previous-contributions/previous-contributions.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-monitor',
    templateUrl: './monitor.component.html',
    styleUrls: ['./monitor.component.css'],
    animations: [
        trigger('slider', [
            state('*', style({
                width: '400px'
            })),
            state('show', style({
                width: '45px'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ]),
        trigger('sliderContent', [
            state('*', style({
                left: '400px',
                width: '{{pageWidth}}px' // avoiding overflow
            }), { params: { pageWidth: 0 } }),
            state('show', style({
                left: '45px',
                width: '{{pageWidth}}px' // avoiding overflow
            }), { params: { pageWidth: 0 } }),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class MonitorComponent implements OnInit, AfterViewChecked, OnDestroy {

  market: MonitorMarket;
  selectedShow: string = '0';
  dataSource;
  displayColumns: string[] = ['contributor', 'loggedIn', 'name'];
  displayColumnsDynamic: string[] = [];
  recordsLength: number = 0;

  remainingTimePublish: string = '0:00:00';
  remainingTimeClose: string = '0:00:00';

  contributions: MarketContribution[] = [];
  intervals: any[] = [];
  newComments: string;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('TABLE') table: ElementRef;
  sidebarOpen: boolean = false;

  isWaitingResults: boolean = false;
  isWaitingInitial: boolean = false;
  isChangedView: boolean = false;

  currentWindowWidth: number;

  // tslint:disable-next-line: max-line-length
  constructor(private translate: TranslateService, @Inject(DOCUMENT) private document: Document, private title: Title, public service: AppService, private dialog: MatDialog, private route: ActivatedRoute, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string, private cdr: ChangeDetectorRef) {
    this.service.SetTranslation('administration/monitor-markets/monitor');
  }

  ngOnInit() {
    this.isWaitingInitial = true;
    this.currentWindowWidth = window.innerWidth;
    this.service.needTemplate = false;
    this.InitializeMarket();
    this.route.queryParams.subscribe(params => {
      this.market.marketId = params['ID'];
      this.GetMarketDetails();
      const interval = setInterval(() => {
        this.service.GetRemainingTime(this.market.marketId, 'Contribution Finish Publish').then(res => {
          this.remainingTimeClose = res.time;
          // if (res.time.split('0').join('').replace(/\:/gi, '').trim() !== '') {
          //   this.GetMarketDetails();
          // }
        });
        this.service.GetRemainingTime(this.market.marketId, 'Calculation Time Publish').then(res => {
          this.remainingTimePublish = res.time;
        });
        this.GetMarketDetails();
      }, 1000);
      this.intervals.push(interval);
    });
    // window.onbeforeunload = () => {
    //   this.service.needTemplate = true;
    // };
  }

  ngAfterViewChecked() {
    // avoid NG0100: ExpressionChangedAfterItHasBeenCheckedError 
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    if (this.intervals.length > 0) {
      this.intervals.forEach(interval => {
        clearInterval(interval);
      });
    }
  }

  /** Gets the current window width */
  getCurrentWidth(): number {
    let width: number = 0;
    if (this.currentWindowWidth) {
      if (this.sidebarOpen) {
        width = this.currentWindowWidth - 400;
      } else {
        width = this.currentWindowWidth - 45;
      }
    } else {
      if (this.sidebarOpen) {
        width = window.innerWidth - 400;
      } else {
        width = window.innerWidth - 45;
      }
    }
    return width;
  }

  /**
   * Listner for window resizing
   * @param event
   */
  onResize(event) {
    const contWindow = this.document.getElementById('contributerInputWindow');
    if (contWindow) {
      if (this.currentWindowWidth > event.target.innerWidth) {
        contWindow.classList.add('scrollableTableHeight');
      } else {
        contWindow.classList.remove('scrollableTableHeight');
      }
    }

    this.currentWindowWidth = event.target.innerWidth; // window width

    const element = this.document.getElementById('monitorMainDrawerContent');
    if (element) {
      element.style.width = this.getCurrentWidth().toString() + 'px';
    }
  }

  /** Gets the market details */
  GetMarketDetails() {
    if (this.isWaitingResults === false) {
      this.isWaitingResults = true;
      this.http.get<MonitorContributions>(this.baseUrl + 'api/monitorMarkets/getMarketDetails/' + this.market.marketId + '/' + this.selectedShow).subscribe(result => {
        this.recordsLength = result.contributions.length;

        if (JSON.stringify(this.market) !== JSON.stringify(result.selectedMarket)) {
          this.newComments = '';
          this.market = result.selectedMarket;
          // Setting the window title
          let status = '';
          if (this.market.status !== '') {
            status = ': ' + this.market.status;
          }
          this.title.setTitle(this.market.code + status);
        }

        if (this.displayColumnsDynamic.length === 0) {
          result.contributions.forEach(con => {
            con.instruments.forEach(ins => {
              if (this.displayColumnsDynamic.includes(ins.description) === false) {
                this.displayColumnsDynamic.push(ins.description);
              }
            });
          });
          this.displayColumns = this.displayColumns.concat(this.displayColumnsDynamic);
        }
        result.contributions.forEach(con => {
          switch (con.status) {
            case 1: {
              con.matIcon = 'done';
              con.matIconColor = 'text-success';
              break;
            }
            case 2: {
              con.matIcon = 'warning';
              con.matIconColor = 'text-warning';
              break;
            }
            case 3: {
              con.matIcon = 'watch_later';
              con.matIconColor = 'text-primary';
              break;
            }
            case 4: {
              con.matIcon = 'flag';
              con.matIconColor = 'text-danger';
              break;
            }
            case 5: {
              con.matIcon = 'fact_check';
              con.matIconColor = 'text-success';
              break;
            }
            case 6: {
              con.matIcon = 'fact_check';
              con.matIconColor = 'text-warning';
              break;
            }
            case 7: {
              con.matIcon = 'fact_check';
              con.matIconColor = 'text-danger';
              break;
            }
          }
        });
        if (this.market.canEnableEdit === false || this.service.currentUser.isReadOnly === true || this.recordsLength === 0) {
          if (this.displayColumns.includes('actions')) {
            const index = this.displayColumns.indexOf('actions');
            this.displayColumns.splice(index, 1);
          }
        } else {
          if (this.displayColumns.includes('actions') === false) {
            this.displayColumns.push('actions');
          }
        }

        if (this.contributions.length === 0 || (this.contributions.length > 0 && JSON.stringify(this.contributions) !== JSON.stringify(result.contributions))) {
          this.contributions = result.contributions;
          this.dataSource = new MatTableDataSource(this.contributions);
          // this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;

          // Soluttion to activate sort on nested values
          this.dataSource.sortingDataAccessor = (item, property) => {
            let user = null;
            if (item.relatedUserInfo.length > 1) {
              user = item.relatedUserInfo[1];
            } else {
              user = item.relatedUserInfo[0];
            }

            if (property === 'name') {
              if (user) {
                return user.firstName + ' ' + user.lastName;
              } else {
                return item[property];
              }
            } else if (property === 'loggedIn') {
              if (user) {
                return user.loggedIn;
              } else {
                return item[property];
              }
            } else if (this.displayColumnsDynamic.includes(property)) {
              return Number(item.instruments.find(i => i.description === property).value);
            } else {
              return item[property];
            }
          };
        }

      }, error => {
        console.error(error);
      }, () => {
        this.isWaitingResults = false;
        this.isWaitingInitial = false;
        this.isChangedView = false;
      });
    }
  }

  ResetChange() {
    this.dataSource = null;
    this.contributions = [];
    this.isChangedView = true;
  }

  /** Initializes the market details */
  InitializeMarket() {
    this.market = {
      marketId: '',
      code: '',
      description: '',
      contributionStart: '',
      contributionFinish: '',
      quorum: 0,
      comments: '',
      status: '',
      extension: 0,
      canEnableEdit: false,
      canEnablePause: false,
      canEnableReCalc: false,
      canVisibleReCalc: false,
      canEnableExtend: false,
      isPaused: false,
      isMarketOpen: false,
      tableFooterHeading: '',
      outliers: null,
      isTransactional: false
    };
  }
  // OnCancel() {
  //   this.dialogRef.close();
  // }

  /**
   * + or ninus button event to change calculation time
   * @param btnVal
   */
  OnClickWindowTimeChange(btnVal: number) {
    this.dialog.open(DialogConfirmComponent, {
      disableClose: true,
      data: {
        title: this.translate.instant('MarketMonitor.monitor.Messages.msdHeaderConfirmSub'),
        message: this.translate.instant('MarketMonitor.monitor.Messages.msgParaChangeCalTime'),
        innerHTML: true
      },
      position: { top: '5%' }
    }).afterClosed().subscribe(res => {
      if (res === true) {
        let response: GRSSResponse = { statusCode: 0, statusMessage: '' };
        if (btnVal > 0) {
          this.http.get<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/updateExtension/' + this.market.marketId + '/up').subscribe(result => {
            response = result;
          }, error => {
            console.error(error);
          });
        } else {
          this.http.get<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/updateExtension/' + this.market.marketId + '/down').subscribe(result => {
            response = result;
          }, error => {
            console.error(error);
          });
        }

        if (response.statusCode === 4) {
          this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderExtend', response.statusMessage);
        } if (response.statusCode === 1) {
          this.GetMarketDetails();
        }
      }
    });
  }

  /**
   * A function to find the matching values
   * @param element
   * @param column
   * @param type
   */
  OnDataBound(element: MarketContribution, column: string, type: string): DataBoundResponse {
    const response: DataBoundResponse = {
      responseOne: '',
      responseTwo: '',
      responseThree: ''
    };
    if (type === 'value') {
      response.responseOne = element.instruments.find(o => o.description === column).cssClass;
      const currentLang = this.service.getLocalLanguage();
      let currentVal = element.instruments.find(o => o.description === column).value;
      let preCalVal =  element.instruments.find(o => o.description === column).preApprovedValue;
      if (!isNaN(Number(currentVal)) && currentVal !== '') {
        let temp: string = currentVal;
        if (temp.includes('.')) {
          temp = temp.replace('-', '');
          const beforeDec = temp.split('.')[0].length.toString();
          const afterDec = temp.split('.')[1].length.toString();
          currentVal = formatNumber(Number(currentVal), currentLang, beforeDec + '.' + afterDec + '-' + afterDec);
          
          if (!isNaN(Number(preCalVal)) && preCalVal !== '') {
            preCalVal = formatNumber(Number(preCalVal), currentLang, beforeDec + '.' + afterDec + '-' + afterDec);
          }
        }
      }
      response.responseThree = currentVal;
      
      if (currentVal !== preCalVal) {
        response.responseTwo = preCalVal;
      }

      return response;
    } else if (type === 'outlier') {
      if (this.market.outliers.length > 0) {
        response.responseOne = this.market.outliers.find(o => o.description === column).cssClass;
        const currentLang = this.service.getLocalLanguage();
        let currentVal =  this.market.outliers.find(o => o.description === column).value;
        let preCalVal =  this.market.outliers.find(o => o.description === column).preApprovedValue;
        if (!isNaN(Number(currentVal)) && currentVal !== '') {
          let temp: string = currentVal;
          if (temp.includes('.')) {
            temp = temp.replace('-', '');
            const beforeDec = temp.split('.')[0].length.toString();
            const afterDec = temp.split('.')[1].length.toString();
            currentVal = formatNumber(Number(currentVal), currentLang, beforeDec + '.' + afterDec + '-' + afterDec);

            if (!isNaN(Number(preCalVal)) && preCalVal !== '') {
              preCalVal = formatNumber(Number(preCalVal), currentLang, beforeDec + '.' + afterDec + '-' + afterDec);
            }
          }
        }
        if (currentVal !== preCalVal) {
          response.responseTwo = preCalVal;
        }
        response.responseThree = currentVal;
        
        return response;
      } else {
        return response;
      }
    }
  }

  /** Comment set event */
  OnClickCommentSet() {
    if (this.service.currentUser.isReadOnly === false) {
      this.market.comments = this.newComments;
      this.http.post<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/addComment', this.market).subscribe(result => {
        if (result.statusCode === 4) {
          this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderComments', result.statusMessage);
        } else {
          this.GetMarketDetails();
        }
      }, error => {
        console.error(error);
      });
    }
  }

  /** Using to close and open sidebar */
  toggleSidebar() {
    this.sidebarOpen = !this.sidebarOpen;
    // if (!this.service.miniSidebarOpen) {
    //   this.treeControl.dataNodes.forEach(node => {
    //     node.hovered = false;
    //   });
    // }
  }

  /**
   * Function to display clicked name contact details
   * @param element Selected contact
   */
  OnClickName(element: MarketContribution) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.position = { top: '5%' };
    dialogConfig.data = {
      element: element,
      type: 'user',
      marketId: ''
    };
    this.dialog.open(DisplayDetailsComponent, dialogConfig);
  }

  /**
   * Status icon click event of a contribution
   * @param element Clicked element details
   */
  OnClickStatus(element: MarketContribution) {
    if (element.status === 4) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.position = { top: '5%' };
      dialogConfig.data = {
        element: element,
        type: 'flag',
        marketId: this.market.marketId
      };
      this.dialog.open(DisplayDetailsComponent, dialogConfig);
    }
  }

  /**
   * Edit icon event of a contribution
   * @param element
   */
  OnEditElement(element: MarketContribution) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '60%';
    dialogConfig.position = { top: '5%' };
    dialogConfig.data = {
      market: element,
      marketId: this.market.marketId,
      isTransactional: this.market.isTransactional
    };
    this.dialog.open(MarketContributeComponent, dialogConfig).afterClosed().subscribe(res => {
      if (res > 0) {
        this.GetMarketDetails();
      }
    });
    // window.open(this.baseUrl + 'admin/monitors/markets/contribute/general?ID=' + this.market.marketId + '&User=' + element.username, '', 'menubar=0,resizable=1,scrollbars=1,width=550,height=450');
  }

  /** Export current details to excel */
  OnClickExport() {
    // const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement); // converts a DOM TABLE element to a worksheet
    // const wb: XLSX.WorkBook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // /* save to file */
    // XLSX.writeFile(wb, this.market.code + ' - ' + moment(new Date()).format('YYYY-MM-DD H:mm:ss') + '.xlsx');

    this.service.showSpinner();
    this.http.get(this.baseUrl + 'api/monitorMarkets/exportData/' + this.market.marketId + '/' + this.selectedShow, { responseType: 'text' }).subscribe(result => {
      if (result !== '') {
        const byteCharacters = atob(result);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.download = this.market.code + ' - ' + moment(new Date()).format('YYYY-MM-DD H:mm:ss') + '.xlsx';
        anchor.href = url;
        anchor.click();
        document.removeChild(anchor);
      } else {
        this.service.SaveStatus(false, 'Messages.msgHeaderExport', 'Messages.msgErrorTryAgain');
      }
    }, error => {
      console.error(error);
    }).add(() => {
      this.service.hideSpinner();
    });

  }

  /** Pause button event */
  OnClickPause() {
    if (this.market.canEnablePause && this.service.currentUser.isReadOnly === false) {
      this.http.get<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/pauseMarket/' + this.market.marketId).subscribe(result => {
        if (result.statusCode === 4) {
          this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderPause', result.statusMessage);
        } else {
          this.GetMarketDetails();
        }
      }, error => {
        console.error(error);
      });
    }
  }

  /** Re-Calc button event */
  OnClickReCalc() {
    if (this.market.canVisibleReCalc && this.market.canEnableReCalc && this.service.currentUser.isReadOnly === false) {
      this.http.get<GRSSResponse>(this.baseUrl + 'api/monitorMarkets/recalculateRates/' + this.market.marketId).subscribe(result => {
        if (result.statusCode === 4) {
          this.service.SaveStatus(true, 'MarketMonitor.monitor.Messages.msgHeaderRecalc', result.statusMessage);
        } else {
          this.GetMarketDetails();
        }
      }, error => {
        console.error(error);
      });
    }
  }

  /**
   * Fires when user click on the contributor
   * @param element Selected contributor
   */
  OnClickContributor(element: MarketContribution) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.width = '90%';
      dialogConfig.position = { top: '5%' };
      dialogConfig.data = {
        contribution: element,
        marketId: this.market.marketId,
        marketCode: this.market.code,
        isTransactional: this.market.isTransactional
      };
      this.dialog.open(PreviousContributionsComponent, dialogConfig);
  }
}

/** An interface to access market monitor details */
interface MonitorMarket {
  marketId: string;
  code: string;
  description: string;
  canEnableEdit: boolean;
  isPaused: boolean;
  isMarketOpen: boolean;
  isTransactional: boolean;
  canEnablePause: boolean;
  canVisibleReCalc: boolean;
  canEnableReCalc: boolean;
  canEnableExtend: boolean;
  quorum: number;
  contributionStart: string;
  contributionFinish: string;
  comments: string;
  status: string;
  extension: number;
  tableFooterHeading: string;
  outliers: MonitorInstrument[];
}

/** An interface to access Market contribution details */
interface MonitorContributions {
  selectedMarket: MonitorMarket;
  contributions: MarketContribution[];
}

/**An interface to access market contribution record details */
interface MarketContribution {
  status: number;
  matIcon: string;
  matIconColor: string;
  contributor: string;
  contributorId: string;
  noOfContributions: number;
  hasRefix: boolean;
  instruments: MonitorInstrument[];
  relatedUserInfo: MarketContributionUser[];
}

/** Interface for access market contributor details */
interface MarketContributionUser {
  roleAs: number;
  userId: string;
  username: string;
  loggedIn: boolean;
  organisationName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  mobile: string;
}

/** An interface to access monitor instrument details */
interface MonitorInstrument {
  instrumentId: string;
  description: string;
  cssClass: string;
  value: string;
  preApprovedValue: string;
}

/** Interface to access databound properties for the view */
interface DataBoundResponse {
  responseOne: string;
  responseTwo: string;
  responseThree: string;
}


